<style>
  input {
    border: none;
    background: none;
    font-size: inherit;
    color: inherit;
    font-weight: inherit;
    text-align: inherit;
    box-shadow: none;
  }
</style>

<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte';

  export let value: string | undefined | null,
    required = true;

  const dispatch = createEventDispatcher();
  let editing = false,
    original: string | undefined | null;

  onMount(() => {
    original = value;
  });

  function edit() {
    editing = true;
  }

  function submit() {
    if (value != original) {
      dispatch('submit', value);
    }

    editing = false;
  }

  function keydown(event: KeyboardEvent) {
    if (event.key == 'Escape') {
      event.preventDefault();
      value = original;
      editing = false;
    }
  }

  function focus(element: HTMLInputElement) {
    element.focus();
  }
</script>

{#if editing}
  <form>
    <input
      on:keydown={keydown}
      bind:value
      on:blur={submit}
      {required}
      use:focus
    />
  </form>
{:else}
  <button
    on:click={edit}
    on:keypress={edit}
    class="cursor-text p-2 hover:rounded-md hover:bg-gray-200"
  >
    {value}
  </button>
{/if}
